module.exports = __webpack_public_path__ + "static/media/anti__bg__1.effb4ddf.png";